import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import bwipjs from 'bwip-js';


function Barcodes({ src }) {
  function createCanvas(src, element) {
    try {
      let newCanvas = bwipjs.toCanvas(element, {
        bcid: 'code128',
        text: src,
        scale: 2,
        height: 8,
        includetext: false,//saca el texto
        textxalign: 'center',
      });
      return newCanvas;
    } catch (e) {
      console.log('error creando el canvas', e);
    }
  }

  const canvasRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    const codebarToCanvas = createCanvas(src, canvasRef.current);
    canvasRef.current = codebarToCanvas;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <canvas ref={canvasRef}></canvas>;
}

Barcodes.propTypes = {
  src: PropTypes.string.isRequired,
};

export default Barcodes;
